<script>
import FormGroup from '@/pages/components/form/horizontal/form-group.vue'
import formInput from "@wielink-application/shared/js/mixins/formInput";
import Email from "@/pages/components/form/input-only/email.vue";

export default {
  mixins: [formInput],
  components: {FormGroup, Email},
  props: {
    'groupClasses': {
      type: String,
      required: false
    },
    'label': {
      type: String,
      required: false
    }
  }
}
</script>

<template>
  <FormGroup :group-classes="groupClasses" :has-error="hasError" :id="renderedId">
    <template #label>{{ label }}</template>

    <Email
        v-bind="$attrs"
        :form="form"
        :name="name"
        :id="renderedId"
        :model-value="modelValue"
        @update:modelValue="changeModelValueTo"
    />
  </FormGroup>
</template>